import { useEffect, useContext, useCallback } from "react";
import { ApiContext } from "../contexts/ApiContext";
import { useDataLoadingReducer } from "./DataLoadingReducer";

export function useDataByCaptureAndDataPointId<T>(captureId?: number, dataPointId?: number, position?: number) {
  const [state, dispatch] = useDataLoadingReducer<T | undefined>(undefined);
  const apiContext = useContext(ApiContext);

  const fetchData = useCallback(() => {
    dispatch({ type: "loading" });
    captureId &&
      dataPointId &&
      apiContext.dataApis
        .getDataByCaptureAndDataPointId<string>(captureId, dataPointId)
        .then((response) => {
          if (response instanceof Error) {
            dispatch({ type: "errored", message: response.message });
          } else {
            let data: T;

            if (!position) {
              data = response && response.length > 0 && JSON.parse(response[0].dataValue);
            } else {
              data = response && response.length > 0 && JSON.parse(response[position].dataValue);
            }

            dispatch({ type: "loaded", data: data });
          }
        })
        .catch((error) => {
          dispatch({ type: "errored", message: error });
        });
  }, [apiContext.dataApis, dispatch, captureId, dataPointId, position]);

  useEffect(() => {
    captureId && dataPointId && fetchData();
  }, [captureId, dataPointId, fetchData]);

  return { ...state, refreshData: fetchData };
}
